import i18n from '@qapline/translations/i18next';

export type TEmailLanguage = 'cs' | 'de' | 'en';

const DISCOUNT_PLACEHOLDER = '{{discount}}';
const EMAIL_TRANSLATION_KEY = 'commissions.export.emailTemplates.createOrderCarrier';
const emailLanguages: TEmailLanguage[] = ['cs', 'de', 'en'];

const getEarlyPayEmailCopy = (language: TEmailLanguage) => {
    const t = i18n.getFixedT(language);
    return {
        offerTemplate: t(`${EMAIL_TRANSLATION_KEY}.earlyPayOffer`, {
            discount: DISCOUNT_PLACEHOLDER,
            interpolation: { escapeValue: false },
        }),
        factoringNotice: t(`${EMAIL_TRANSLATION_KEY}.factoringNotice`),
    };
};

const escapeRegExp = (value: string) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

const earlyPayOfferPatterns = emailLanguages.map((language) => {
    const { offerTemplate } = getEarlyPayEmailCopy(language);
    const [prefix, suffix] = offerTemplate.split(DISCOUNT_PLACEHOLDER);
    return new RegExp(`${escapeRegExp(prefix)}\\d+(?:[.,]\\d+)?${escapeRegExp(suffix)}`, 'g');
});

export const getEarlyPayFactoringNotice = (language: TEmailLanguage) => getEarlyPayEmailCopy(language).factoringNotice;

export const getValidEarlyPayDiscount = (value: unknown): number | undefined => {
    if (typeof value !== 'number' || !Number.isFinite(value) || value <= 0 || value >= 100) return undefined;
    if (Math.abs(value * 100 - Math.round(value * 100)) >= 1e-8) return undefined;
    return value;
};

export const removeEarlyPayEmailOffer = (message: string) =>
    earlyPayOfferPatterns
        .reduce((updatedMessage, pattern) => updatedMessage.replace(pattern, ''), message)
        .replace(/\n[ \t]*\n[ \t]*\n+/g, '\n\n');

export const updateEarlyPayEmailOffer = ({
    message,
    language,
    offered,
    discount,
}: {
    message: string;
    language: TEmailLanguage;
    offered: boolean;
    discount?: unknown;
}) => {
    if (!offered) return removeEarlyPayEmailOffer(message);

    const validDiscount = getValidEarlyPayDiscount(discount);
    if (validDiscount === undefined) return message;

    const messageWithoutOffer = removeEarlyPayEmailOffer(message);
    const localizedDiscount = language === 'en' ? String(validDiscount) : String(validDiscount).replace('.', ',');
    const { offerTemplate, factoringNotice } = getEarlyPayEmailCopy(language);
    const offer = offerTemplate.replace(DISCOUNT_PLACEHOLDER, localizedDiscount);

    if (messageWithoutOffer.includes(factoringNotice)) {
        return messageWithoutOffer.replace(factoringNotice, `${offer}\n\n${factoringNotice}`);
    }

    return `${messageWithoutOffer.trimEnd()}\n\n${offer}`;
};
